<admin-table-standard [items]="alert.hits" [custom]="['inner-table']">
  <ng-template #header>
    <th class="text-lowercase" style="width: 15%">list field</th>
    <th class="text-lowercase" style="width: 15%">data field</th>
    <th class="text-lowercase" style="width: 25%">list value</th>
    <th class="text-lowercase" style="width: 25%">data value</th>
    <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.threshold' | translate}}</th>
    <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.weight' | translate}}</th>
    <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.similarity' | translate}}</th>
    <th class="text-center" style="width: 5%">{{'pages.channels.view.checks.score' | translate}}</th>
  </ng-template>
  <ng-template #first let-item>
    <td class="text-dark">{{ item.listField }}</td>
    <td class="text-dark">{{ item.dataField }}</td>
    <td class="text-dark">{{ item.listData }}</td>
    <td class="text-dark">{{ item.dataCandidate }}</td>
    <td class="threshold-label fw-bolder align-middle text-center">{{ (getNumberValue(item.threshold) * 100).toFixed(0) }} %</td>
    <td class="weight-label fw-bolder align-middle text-center">{{ getNumberValue(item.value).toFixed(2) }}</td>
    <td class="fw-bolder align-middle text-center">{{ (getNumberValue(item.score) * 100).toFixed(0) }} %</td>
    <td [ngClass]="'fw-bolder align-middle text-center'">{{ getNumberValue(item.result).toFixed(1) }}</td>
  </ng-template>
</admin-table-standard>
